// Filters Style Plugin
import { createColorProperty, createSimpleProperty } from "./helpers.js";
export default {
    id: 'filters',
    label: 'Filters',
    icon: 'Droplet',
    properties: {
        filter: {
            label: 'Filter',
            type: 'select',
            options: ['filter', 'filter-none'],
            default: 'filter-none',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['filter', 'filter-none'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        blur: {
            label: 'Blur',
            type: 'select',
            options: ['xs', 'sm', 'default', 'md', 'lg', 'xl', '2xl', '3xl', 'none'],
            default: 'none',
            toClass: (value) => {
                if (value === 'default') return 'blur';
                return value ? `blur-${value}` : null;
            },
            fromClass: (className) => {
                if (className === 'blur') return 'default';
                const match = className.match(/^blur-(.+)$/);
                return match ? match[1] : null;
            }
        },
        brightness: {
            label: 'Brightness',
            type: 'select',
            options: ['0', '50', '75', '90', '95', '100', '105', '110', '125', '150', '200'],
            default: '100',
            ...createSimpleProperty('brightness')
        },
        contrast: {
            label: 'Contrast',
            type: 'select',
            options: ['0', '50', '75', '100', '125', '150', '200'],
            default: '100',
            ...createSimpleProperty('contrast')
        },
        dropShadow: {
            label: 'Drop Shadow',
            type: 'select',
            options: ['xs', 'sm', 'default', 'md', 'lg', 'xl', '2xl', 'none'],
            default: 'none',
            toClass: (value) => {
                if (value === 'default') return 'drop-shadow';
                return value ? `drop-shadow-${value}` : null;
            },
            fromClass: (className) => {
                if (className === 'drop-shadow') return 'default';
                const match = className.match(/^drop-shadow-(.+)$/);
                return match ? match[1] : null;
            }
        },
        dropShadowColor: {
            label: 'Drop Shadow Color',
            type: 'color',
            default: null,
            toClass: () => null, // Force inline styles
            fromClass: (className) => {
                const match = className.match(/^drop-shadow-(.+)$/);
                if (match) {
                    const colorValue = match[1];
                    if (colorValue.startsWith('[') && colorValue.endsWith(']')) {
                        return colorValue.slice(1, -1);
                    }
                    if (['xs', 'sm', 'md', 'lg', 'xl', '2xl', 'none'].includes(colorValue)) return null;
                    return colorValue;
                }
                return null;
            }
        },
        grayscale: {
            label: 'Grayscale',
            type: 'select',
            options: ['grayscale', 'grayscale-0'],
            default: 'grayscale-0',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['grayscale', 'grayscale-0'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        hueRotate: {
            label: 'Hue Rotate',
            type: 'select',
            options: ['0', '15', '30', '60', '90', '180'],
            default: '0',
            ...createSimpleProperty('hue-rotate')
        },
        invert: {
            label: 'Invert',
            type: 'select',
            options: ['invert', 'invert-0'],
            default: 'invert-0',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['invert', 'invert-0'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        saturate: {
            label: 'Saturate',
            type: 'select',
            options: ['0', '50', '100', '150', '200'],
            default: '100',
            ...createSimpleProperty('saturate')
        },
        sepia: {
            label: 'Sepia',
            type: 'select',
            options: ['sepia', 'sepia-0'],
            default: 'sepia-0',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['sepia', 'sepia-0'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        backdropFilter: {
            label: 'Backdrop Filter',
            type: 'select',
            options: ['filter', 'filter-none'],
            default: 'filter-none',
            toClass: (value) => value ? `backdrop-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^backdrop-(filter|filter-none)$/);
                return match ? match[1] : null;
            }
        },
        backdropBlur: {
            label: 'Backdrop Blur',
            type: 'select',
            options: ['xs', 'sm', 'default', 'md', 'lg', 'xl', '2xl', '3xl', 'none'],
            default: 'none',
            toClass: (value) => {
                if (value === 'default') return 'backdrop-blur';
                return value ? `backdrop-blur-${value}` : null;
            },
            fromClass: (className) => {
                if (className === 'backdrop-blur') return 'default';
                const match = className.match(/^backdrop-blur-(.+)$/);
                return match ? match[1] : null;
            }
        },
        backdropBrightness: {
            label: 'Backdrop Brightness',
            type: 'select',
            options: ['0', '50', '75', '90', '95', '100', '105', '110', '125', '150', '200'],
            default: '100',
            ...createSimpleProperty('backdrop-brightness')
        },
        backdropContrast: {
            label: 'Backdrop Contrast',
            type: 'select',
            options: ['0', '50', '75', '100', '125', '150', '200'],
            default: '100',
            ...createSimpleProperty('backdrop-contrast')
        },
        backdropGrayscale: {
            label: 'Backdrop Grayscale',
            type: 'select',
            options: ['backdrop-grayscale', 'backdrop-grayscale-0'],
            default: 'backdrop-grayscale-0',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['backdrop-grayscale', 'backdrop-grayscale-0'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        backdropHueRotate: {
            label: 'Backdrop Hue Rotate',
            type: 'select',
            options: ['0', '15', '30', '60', '90', '180'],
            default: '0',
            ...createSimpleProperty('backdrop-hue-rotate')
        },
        backdropInvert: {
            label: 'Backdrop Invert',
            type: 'select',
            options: ['backdrop-invert', 'backdrop-invert-0'],
            default: 'backdrop-invert-0',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['backdrop-invert', 'backdrop-invert-0'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        backdropOpacity: {
            label: 'Backdrop Opacity',
            type: 'select',
            options: ['0', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90', '95', '100'],
            default: '100',
            ...createSimpleProperty('backdrop-opacity')
        },
        backdropSaturate: {
            label: 'Backdrop Saturate',
            type: 'select',
            options: ['0', '50', '100', '150', '200'],
            default: '100',
            ...createSimpleProperty('backdrop-saturate')
        },
        backdropSepia: {
            label: 'Backdrop Sepia',
            type: 'select',
            options: ['backdrop-sepia', 'backdrop-sepia-0'],
            default: 'backdrop-sepia-0',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['backdrop-sepia', 'backdrop-sepia-0'].includes(className)) {
                    return className;
                }
                return null;
            }
        }
    }
};
